import { DateTime } from 'luxon';

export const toISODate = (date: DateTime) => {
  return date.startOf('day').startOf('second').toISO({ suppressMilliseconds: true }) as string;
};

export const getNextYear = () => {
  const nextYear = DateTime.fromJSDate(new Date()).plus({ years: 1 });
  return toISODate(nextYear.setZone('Europe/Berlin'));
};
